"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_public__sector__dark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b3a654de-f146-40c5-8460-508c033bc434",
    x1: -13700.14,
    y1: -6651.13,
    x2: -13609.37,
    y2: -6560.36,
    gradientTransform: "matrix(0.36, -0.05, -0.05, 0.36, 4634.26, 1797.86)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "597b63ae-392b-4266-a957-761f808634e5",
    x1: -13561.21,
    y1: -6632,
    x2: -13470.43,
    y2: -6541.23,
    xlinkHref: "#b3a654de-f146-40c5-8460-508c033bc434"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "79845f5b-ac73-42b8-9187-d3dfc5c0f245",
    x1: -13425.07,
    y1: -6613.3,
    x2: -13334.3,
    y2: -6522.52,
    xlinkHref: "#b3a654de-f146-40c5-8460-508c033bc434"
  }), /*#__PURE__*/React.createElement("symbol", {
    id: "572d1aaf-7fcc-40f6-9738-d812163ef6ad",
    "data-name": "Public_sector_ic_hi",
    viewBox: "0 0 192 192"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 59.25,
    y: 88,
    width: 73,
    height: 40,
    fill: "#4a4d4e"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35.25,
    y: 86.83,
    width: 24,
    height: 42.17,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84.25,
    y: 86.83,
    width: 24,
    height: 42.17,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132.25,
    y: 86.83,
    width: 24,
    height: 42.17,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35.25,
    y: 86.83,
    width: 24,
    height: 42.17,
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84.25,
    y: 86.83,
    width: 24,
    height: 42.17,
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132.25,
    y: 86.83,
    width: 24,
    height: 42.17,
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.25,
    y: 128,
    width: 144,
    height: 24,
    rx: 4,
    ry: 4,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.25,
    y: 143.92,
    width: 159.93,
    height: 24,
    rx: 4,
    ry: 4,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.25,
    y: 142,
    width: 144,
    height: 2,
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.25,
    y: 148,
    width: 160,
    height: 2,
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.25,
    y: 154,
    width: 160,
    height: 2,
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.25,
    y: 160,
    width: 160,
    height: 2,
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.25,84V70.3a4,4,0,0,1,2-3.45L94,23.38a4,4,0,0,1,4.31,0l67.94,43.46a4,4,0,0,1,2,3.46V84a4,4,0,0,1-4,4h-136A4,4,0,0,1,24.25,84Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164,86H28a4,4,0,0,1-4-4v2a4,4,0,0,0,4,4H164a4,4,0,0,0,4-4V82A4,4,0,0,1,164,86Z",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.18,166H20.25a4,4,0,0,1-4-4v2a4,4,0,0,0,4,4H172.18a4,4,0,0,0,4-4v-2A4,4,0,0,1,172.18,166Z",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.25,68h144a0,0,0,0,1,0,0V84a4,4,0,0,1-4,4h-136a4,4,0,0,1-4-4V68A0,0,0,0,1,24.25,68Z",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "59.25 120.28 35.25 96.17 35.25 88 59.25 88 59.25 120.28",
    opacity: 0.2,
    fill: "url(#b3a654de-f146-40c5-8460-508c033bc434)"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "108.25 120.28 84.25 96.17 84.25 88 108.19 88 108.25 120.28",
    opacity: 0.2,
    fill: "url(#597b63ae-392b-4266-a957-761f808634e5)"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "156.25 120.28 132.25 96.17 132.25 88 156.19 88 156.25 120.28",
    opacity: 0.2,
    fill: "url(#79845f5b-ac73-42b8-9187-d3dfc5c0f245)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("title", null, "public-sector-hi-dark"), /*#__PURE__*/React.createElement("g", {
    id: "b3cac6d1-4f34-4f4b-a439-2400e065ad75",
    "data-name": "Public_sector_ic"
  }, /*#__PURE__*/React.createElement("use", {
    id: "1452b892-cc24-4c28-91aa-0ec35c9224ef",
    "data-name": "Public_sector_ic_hi",
    width: 192,
    height: 192,
    xlinkHref: "#572d1aaf-7fcc-40f6-9738-d812163ef6ad"
  })));
}

var _default = ic_public__sector__dark;
exports.default = _default;